
export const USER_QUERY = `
query UserQuery {
  user {
    username
    user_id
    profile {
      organizations {
        primary
        organization_id
        display_labels {
          locale
          label
        }
      }
      names {
        locale
        name {
          first_name
          full_name
          latest_system_name
          active
        }
      }
    }
  }
}

`;